export default __webpack_public_path__ + "static/media/JobsActiveIcon.0e12fc08.svg";